export default function useUserPilotTracking() {
  const sendUserPilotTrackingEvent = async (title, metadata) => {
    global.userpilot.track(title, metadata);
  };

  return { sendUserPilotTrackingEvent };
}
